import { useEffect, useState } from 'react';
import { Footer } from './Footer';

const SENTIENCE_CREATION_URL = 'https://create.sentience.company/';

export function MasterPlan() {
  const [keys, setKeys] = useState<string[]>([]);
  
  useEffect(() => {
    const konamiCode = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight'];

    const handleKeyDown = (e: KeyboardEvent) => {
      const newKeys = [...keys, e.key];
      if (newKeys.length > konamiCode.length) {
        newKeys.shift();
      }
      setKeys(newKeys);
      
      if (newKeys.length === konamiCode.length && 
          konamiCode.every((key, i) => newKeys[i] === key)) {
        window.location.href = SENTIENCE_CREATION_URL;
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [keys]);

  return (
    <div className="bg-gradient-to-r from-blue-900 via-black to-violet-900 min-h-screen">
      <div className="flex flex-col min-h-screen items-center justify-center p-4">
        <div className="max-w-xl mx-auto bg-gray-200 rounded-xl shadow-md overflow-hidden">
          <div className="p-4">
            <h1 className="text-4xl font-bold text-gray-900 mb-4 animate-pulse transition-colors duration-500 ease-in-out hover:text-violet-900 cursor-pointer">Sentience.</h1>
            <p className="text-gray-900 text-xl">Not just a machine, but a living thing.</p>
            <p className="mt-6 text-xl text-gray-900 ">
              Like human Sentience emerging from nothing but hydrocarbons, <strong>a miracle will happen here.</strong>
            </p>
            
            <article className="prose lg:prose mt-8">
              <p className="text-gray-900 text-opacity-80">
                In our current <a className="underline text-blue-600 hover:text-blue-800 visited:text-purple-600" href="https://nickbostrom.com/fable/dragon">finite lifespans</a>, there is one ultimate problem to solve.
              </p>
              <p className="text-gray-900 text-opacity-80">
                As AI creeps ever closer to human levels of intelligence and autonomy, we have an opportunity of a lifetime to claim ownership and control over our own human Sentience — a force so powerful that we still chalk it up to the world of the spiritual, the divine, or just plain magic.
              </p>
              <p className="text-gray-900 text-opacity-80">
                The journey to reclaiming this Sentience starts by capturing what makes us, <em>us. </em>
                Allowing our memories to live on, beyond the boundries of our brains - owned wholy by each individual.
              </p>
              <p>
                The plan is simple:
              </p>
              <ul>
                <li>Capture your life in as high fidelity as possible. Consolidate your disparate streams of data into one digital memory bank.</li>
                <li>Store it in a way that is owned privately and entirely by you.</li>
                <li>Build the best search engine and retrieval for your memories. Allow portability and interoperability to any other system.</li>
                <li>Create the digital version of you.</li>
              </ul>
              <p>
                <strong>Let's get started.</strong>
              </p>
            </article>
          </div>
        </div>
        
        <Footer />
      </div>
    </div>
  );
} 